import axios from "axios";
import { Message, Loading } from "element-ui";
import router from "../router";
import { commonParams, base, postCommonParams } from "./common_query.js";

//普通post请求：
export let postRequest = (url, params) => {
  params = Object.assign({}, params);
  params.loginToken=localStorage.getItem("loginToken")
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        ret = ret.substring(0, ret.length - 1);
        return ret;
      }
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};

//普通get请求：
export let getRequest = (url, params) => {
  let config = {
    method: "get",
    url: `${base}${url}`
  };
  let configs
  if (params && params.params) {
    params.params = Object.assign({}, params.params);
    params.params.loginToken=localStorage.getItem("loginToken")
    configs = Object.assign({}, config, params);
  }else{
    let loginObj={
      params:{
        loginToken:localStorage.getItem("loginToken")
      }
    }
    configs = Object.assign({}, config, loginObj);
  }
  return axios(configs);
};

//普通put请求：
export let putRequest = (url, params) => {
  return axios({
    method: "put",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      }
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};
//普通删除请求：
export let deleteRequest = url => {
  return axios({
    method: "delete",
    url: `${base}${url}`
  });
};

//普通表单上传不需要转换成formDate请求：
export const uploadFileRequest = (url, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  Message({
    message: msg,
    duration: 1000,
    forbidClick: true
  });
};
//请求拦截：
var loadingInstance;
axios.interceptors.request.use(
  config => {
    loadingInstance = Loading.service({ fullscreen: true });
    //Indicator.close();
    return config;
  },
  err => {
    loadingInstance.close();
    tip("提示:请求超时!");
    return Promise.resolve(err);
  }
);
axios.interceptors.response.use(
  data => {
    // if (data.data.errcode == "1") {
    //   tip("提示", "用户过期,请重新登录");
    //   setTimeout(() => {
    //     // toLogin();
    //   }, 2000);
    // }
    if (data.status && data.status == 200 && data.data.status == "error") {
      tip("提示:请求错误");
      loadingInstance.close();
      return;
    }
    loadingInstance.close();
    return data;
  },
  err => {
    loadingInstance.close();
    if (err.response.status == 504 || err.response.status == 404) {
      tip("提示:服务器⊙﹏⊙∥");
    } else if (err.response.status == 403) {
      tip("提示:权限不足,请联系管理员!");
    } else {
      tip("提示:未知错误!");
    }
    return Promise.resolve(err);
  }
);
